export default class Constants {
}
Constants.funWalletLeaderId = 'fun-wallet-leader';
Constants.leaderModalClassName = 'fun-wallet-leader-modal';
Constants.darkenLightBoxClassName = 'fun-wallet-darken';
Constants.isFunWalletAttributeName = 'is-fun-wallet';
Constants.isLeaderAttributeName = 'is-leader';
Constants.isFollowerAttributeName = 'is-follower';
Constants.trackingMetaTagName = 'x-tracking-id';
Constants.funWalletRouteQueryParameterName = 'funWalletRoute';
//# sourceMappingURL=constants.js.map